import api from "../services/api";


export const submitContact = async (formData) => {
  try {
    const response = await api.post("/Contact", formData);
    return response.data;
  } catch (error) {
    console.error("Error submitting contact form", error);
    throw error;
  }
};
